module.exports = __webpack_public_path__ + "img/1506043566.b5859bb7.jpg";